import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/settings')({
	beforeLoad: () => {
		throw redirect({ to: '/account' })
	}
})
